/*eslint unicode-bom: "off"*/
import { DialogContentText } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { createContext, Dispatch, ReactElement, SetStateAction, useContext, useState } from 'react';
import { VdsButton, VdsDialog, VdsDialogProps } from "../vds";

const UpdateDialogContext = createContext(null);

type DialogProps = {
    variant: VdsDialogProps['variant'],
    text?: string,
    yesText?: string,
    title: string | ReactElement,
    content: string | ReactElement,
    open: boolean,
    yesCallback?: (close: () => void) => void,
    endCallback: (close: () => void) => void
};

export const useDialogContext: () => Dispatch<SetStateAction<DialogProps>> = () => useContext(UpdateDialogContext);

export const DialogContextProvider = ({ children }) => {

    const [dialog, setDialog] = useState<DialogProps>({
        variant: 'default',
        title: '',
        text: '',
        yesText: '',
        content: '',
        open: false,
        yesCallback: () => { },
        endCallback: () => { },
    });

    const closeDialog = () => setDialog({
        ...dialog,
        open: false,
    });

    return (
        <UpdateDialogContext.Provider value={setDialog}>
            <React.Fragment>
                {children}
                <VdsDialog
                    open={dialog.open}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <DialogTitle>{dialog.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {dialog.content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        {dialog.yesCallback && (
                            <VdsButton
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={() => {
                                    dialog.yesCallback(closeDialog);
                                }}
                            >
                                <React.Fragment>
                                    {dialog?.yesText || "Chiudi"}
                                </React.Fragment>
                            </VdsButton>
                        )}
                        <VdsButton
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                dialog.endCallback(closeDialog);
                            }}
                        >
                            <React.Fragment>
                                {dialog?.text || "Annulla"}
                            </React.Fragment>
                        </VdsButton>
                    </DialogActions>
                </VdsDialog>
            </React.Fragment>
        </UpdateDialogContext.Provider>
    );
};
